'use strict';

(function (angular) {
    angular
        .module('jwsdw.util')
        .constant('NUMBER_FORMAT', window.jwsdwSettings.numberFormat)
        .constant('IMAGE_BASE_URL', window.jwsdwSettings.productGetImageBaseUrl);
}(angular));